import { ILoginActions, eLoginActions } from "../../action-types/auth/ILoginActions";
import { ILoginReducer } from "../../reducer-model/auth/ILoginReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ILoginReducer = {
    status: eReducerStatusBase.is_not_initialization,
    message: undefined
}
export const loginReducer = (state: ILoginReducer = iniState, action: ILoginActions): ILoginReducer => {
    switch (action.type) {
        case eLoginActions.LOGIN_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                message: undefined
            }
        case eLoginActions.LOGIN_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                message: undefined
            }
        case eLoginActions.LOGIN_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                message: action.payload
            }

        default:
            return {
                ...state
            }
    }
}